<template>
  <div v-loading="loading" class="growth">
    <div v-if="material.length" class="growth-top">
      <el-button type="primary" class="add" @click="showAddMaterial">添加新巡店记录</el-button>
      <el-select
        @change="getGrowthList(true)"
        @clear="getGrowthList(true)"
        v-model="query.followType"
        clearable
        placeholder="记录类型"
        class="growth-type"
      >
        <el-option
          v-for="item in followType"
          :key="item.option"
          :label="item.option"
          :value="item.option"
        ></el-option>
      </el-select>
      <div class="divider"></div>
      <el-select v-model="inputValue" @change="employeTime" placeholder="请选择" class="handle-select">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <div v-if="inputValue !== 'all'" class="date-box">
        <el-date-picker
          v-model="time"
          type="daterange"
          unlink-panels
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="chooseTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </div>
    </div>
    <div class="material-record">
      <!-- 档案列表 -->
      <div class="material-group" v-if="material.length">
        <div class="timeline">
          <div class="item" v-for="(item,index) in material" :key="index">
            <div class="title">
              <div class="tite-left">
                <span class="name">{{item.followType}}</span>
                <span>分销商门店巡店记录：</span>
                <span class="name">{{employeInfo.name}}</span>
                <span>{{item.description}}</span>
              </div>
              <div class="flex">
                <el-upload
                  ref="upload"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :file-list="fileList"
                  :show-file-list="false"
                  :data="{id:item.id,index}"
                  :http-request="uploadGrowthRecordMaterials"
                  multiple
                  accept=".jpg, .png, .jpeg, .mp4, .txt, .pdf, .doc, .docx, .xlsx"
                >
                  <span slot="trigger" class="title-action">资料上传</span>
                </el-upload>
                <span class="title-action" @click="edit(item,index)">编辑</span>
                <span class="title-action" @click="deleteGrowthRecord(item.id,index)">删除</span>
              </div>
              <!-- 日期时间 -->
              <div class="date">
                <div class="year">{{item.year}}</div>
                <div class="mounth">{{item.day}}</div>
              </div>
            </div>
            <div class="content">
              <!-- 图片 -->
              <div class="flex">
                <div class="img-group" v-for="(imgItem,imgIndex) in item.imgList" :key="imgIndex">
                  <el-image
                    class="img"
                    :src="imgItem.url"
                    fit="cover"
                    :preview-src-list="previewImgList(item.imgList)"
                  ></el-image>
                  <div class="info">
                    <div class="flex-between">
                      <div>
                        <div>{{employeInfo.name}}</div>
                        <div>{{imgItem.creationTime.substr(0,10)}}</div>
                      </div>
                      <div
                        class="del-group"
                        @click="deleteMaterialFile(item.id,imgItem.id,index,'imgList',imgIndex)"
                      >
                        <svg-icon class="del-icon" icon-class="del-ico"></svg-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 视频 -->
              <div class="flex">
                <div
                  class="video-group"
                  v-for="(videoItem,videoIndex) in item.videoList"
                  :key="videoIndex"
                  @click="videoUrl=videoItem.url"
                >
                  <video class="video" :src="videoItem.url"></video>
                  <div class="info">
                    <div class="flex-between">
                      <div>
                        <div>{{employeInfo.name}}</div>
                        <div>{{videoItem.creationTime.substr(0,10)}}</div>
                      </div>
                      <div
                        class="del-group"
                        @click.stop="deleteMaterialFile(item.id,videoItem.id,index,'videoList',videoIndex)"
                      >
                        <svg-icon class="del-icon" icon-class="del-ico"></svg-icon>
                      </div>
                    </div>
                  </div>
                  <div class="play">
                    <svg-icon icon-class="arrow-down" class="arrow" />
                  </div>
                </div>
              </div>
              <!-- 文件 -->
              <div class="files-group" v-if="item.textList.length>0">
                <div class="file" v-for="(textItem,textIndex) in item.textList" :key="textIndex">
                  <span class="file-title">【资料文件】 {{textItem.fileName}}</span>
                  <!-- <span class="file-size">163.00kb</span> -->
                  <span @click="previewFile(textItem.url)" class="file-action">预览</span>
                  <span
                    class="file-action"
                    @click="downloadGrowthRecordMaterial(textItem.fileName)"
                  >下载</span>
                  <span
                    class="file-action"
                    @click="deleteMaterialFile(item.id,textItem.id,index,'textList',textIndex)"
                  >移除</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 查看更多 -->
          <div class="load-more-group">
            <div v-if="noMore" class="load-more no-more">没有更多数据了</div>
            <div v-else class="load-more" @click="getGrowthList()">查看更多</div>
          </div>
        </div>
      </div>
      <!-- 无档案 -->
      <div class="material-empty" v-else>
        <div class="empty-box">
          <img
            src="@/assets/image/material-empty.gif"
            alt="empty-img"
            class="empty-img"
          />
          <div class="empty-main">
            <p>{{(query.followType||query.startTime)?'当前筛选条件下暂无巡店记录':'当前分销商门店暂无巡店记录'}}，点击下方“立即添加”按钮 新建巡店记录。</p>
            <el-button type="primary" @click="showAddMaterial">立即添加</el-button>
          </div>
        </div>
      </div>
      <!-- 悬浮按钮 -->
      <el-popover
        v-if="material.length"
        placement="left"
        width="190"
        height="44"
        trigger="hover"
        content="拖拽调整位置，点击新增巡店记录"
      >
        <div
          slot="reference"
          class="add-file"
          ref="addFile"
          @mousedown="mouseDownHandleelse($event)"
          @mouseup="mouseUpHandleelse($event)"
        >+</div>
      </el-popover>
      <!-- 视频播放 -->
      <videoPlay v-if="videoUrl" :url="videoUrl" @closeVideo="closeVideo"></videoPlay>
      <!-- 添加新记录 -->
      <el-form
        v-if="isShowAdd"
        ref="addQuery"
        :model="addQuery"
        :rules="addRules"
        label-width="5rem"
      >
        <el-dialog
          :title="(dialogType=='add'?'添加':'管理') + '巡店记录'"
          :visible.sync="isShowAdd"
          width="600px"
          height="306px"
        >
          <div class="add-record">
            <el-form-item label="记录类型" prop="type">
              <el-select v-model="addQuery.type" placeholder="请选择记录类型" clearable>
                <el-option
                  v-for="item in followType"
                  :key="item.option"
                  :label="item.option"
                  :value="item.option"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="记录时间" prop="time">
              <el-date-picker
                value-format="yyyy-MM-dd hh:mm:ss"
                format="yyyy-MM-dd"
                v-model="addQuery.time"
                type="date"
                clearable
                placeholder="请选择记录时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="记录描述" class="auto-height" prop="desc">
              <el-input
                type="textarea"
                v-model="addQuery.desc"
                maxlength="200"
                show-word-limit
                placeholder="请输入记录描述"
                clearable
                resize="none"
              ></el-input>
            </el-form-item>
            <el-form-item
              class="auto-height clear-margin-top"
              label="资料文件"
              v-if="dialogType=='add'"
            >
              <!-- v-if="(addQuery.imgList.length>0||addQuery.videoList.length>0||addQuery.textList.length>0)&&dialogType=='add'" -->
              <div style="padding-bottom:10px;">
                <el-upload
                  ref="upload"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :on-change="uploadChange"
                  :file-list="fileList"
                  :show-file-list="false"
                  :auto-upload="false"
                  multiple
                  accept=".jpg, .png, .jpeg, .mp4, .txt, .pdf, .doc, .docx, .xlsx"
                >
                  <el-button v-if="dialogType=='add'" slot="trigger">上传资料</el-button>
                </el-upload>
              </div>
              <div class="add-record-content">
                <!-- 图片 -->
                <div class="flex">
                  <div class="img-group" v-for="(item,index) in addQuery.imgList" :key="index">
                    <el-image class="img" :src="item.url" fit="cover"></el-image>
                    <div class="info">
                      <div class="name">{{item.name}}</div>
                      <div class="flex-between">
                        <div>{{item.creationTime.substr(0,10)}}</div>
                        <div @click="delFile('imgList',index,item.uid)">
                          <svg-icon class="del-icon" icon-class="del-ico"></svg-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 视频 -->
                <div class="flex">
                  <div
                    class="video-group"
                    v-for="(item,index) in addQuery.videoList"
                    :key="index"
                    @click="videoUrl=item.url"
                  >
                    <video class="video" :src="item.url"></video>
                    <div class="play">
                      <svg-icon icon-class="arrow-down" class="arrow" />
                    </div>
                    <div class="info">
                      <div class="name">{{item.name}}</div>
                      <div class="flex-between">
                        <div>{{item.creationTime.substr(0,10)}}</div>
                        <div @click.stop="delFile('videoList',index,item.uid)">
                          <svg-icon class="del-icon" icon-class="del-ico"></svg-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 文件 -->
                <div class="files-group">
                  <div class="file" v-for="(item,index) in addQuery.textList" :key="index">
                    <span class="file-title">【资料文件】 {{item.name}}</span>
                    <span class="file-action" @click="delFile('textList',index,item.uid)">删除</span>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isShowAdd = false">取消</el-button>
            <el-button type="primary" @click="creatSubmit('addQuery')" :loading="uploading">确定</el-button>
          </span>
        </el-dialog>
      </el-form>
    </div>
    <!-- 预览pdf -->
    <el-dialog
      title="预览"
      :visible.sync="isPdfShow"
      width="100%"
      height="100%"
      custom-class="preview-pdf"
      :before-close="closeDialog"
    >
      <div class="pdf">
        <pdf v-if="isPdfShow" :src="pdfSrc"></pdf>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import followJs from './follow.js';
export default {
  ...followJs
}
</script>

<style lang="scss" scoped>
@import "./material-record.scss";
.growth {
  .material-group {
    padding: 0 28px 78px 15px;
  }
  .growth-top {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .growth-type {
      margin-left: 10px;
      width: 90px;
    }
    .el-select{
      width: 120px;
    }
    ::v-deep .handle-select{
      .el-input__inner{
      border-radius:4px 0 0 4px;
      }
    }
    ::v-deep .date-box {
      .el-input__inner {
        border-radius: 0 4px 4px 0;
        border-left: 1px solid transparent;
        transition: ease all 0.3s;
        &.isactive {
          border-left: 1px solid #006eff;
        }
      }

      .el-icon-circle-close,
      .el-range-separator {
        position: relative;
        top: 0px;
      }
    }
  }

  .growth-main {
    height: 440px;
    background: #fff;
    // box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);

    .main-item {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>